import moment from "moment-timezone";
import stateSettingsAndCustomization from '../settingsAndCustomize/state'
import xlooLib from "../../../librarys/xlooLib";

export default {
    set_temporaryAccount: (state, payload)=> { state.temporaryAccount = payload },
    set_idDonor: (state, payload)=> { state.idDonor = payload },
    set_firstName: (state, payload)=> { state.firstName = payload },
    set_lastName: (state, payload)=> { state.lastName = payload },
    set_dob: (state, payload)=> { state.dob = moment(payload).format("MM/DD/YYYY") },
    set_phoneMobile: (state, payload)=> {
        state.mobilePhone = xlooLib.phoneFormat(payload, stateSettingsAndCustomization.crmSettings.phoneFormat)
    },
    set_phoneHome: (state, payload)=> {
        state.homePhone =  xlooLib.phoneFormat(payload, stateSettingsAndCustomization.crmSettings.phoneFormat)
    },
    set_email: (state, payload)=> { state.email = payload },
    set_street: (state, payload)=> { state.street = payload },
    set_city: (state, payload)=> { state.city = payload },
    set_state: (state, payload)=> { state.state = payload },
    set_country: (state, payload)=> { state.country = payload },
    set_zipCode: (state, payload)=> { state.zipCode = payload },
    set_lat: (state, payload)=> { state.lat = payload },
    set_lng: (state, payload)=> { state.lng = payload },
    set_bloodType: (state, payload)=> { state.bloodType = payload },
    set_donorId: (state, payload)=> { state.donorId = payload },
    set_smsOptedOut: (state, payload)=> {
        state.smsOptedOut = typeof payload ==="boolean" ? payload : payload !== '0'
    },
    set_prohibitingStatuse: (state, payload)=> { state.prohibitingStatuse = payload },
    set_pointsTotal: (state, payload)=> { state.pointsTotal = payload },
    set_sumRewardsPoints: (state, payload)=> { state.sumRewardsPoints = payload },
    set_lifetimeDonations: (state, payload)=> { state.lifetimeDonations = payload },
    set_lifetimeDonationsWbc: (state, payload)=> { state.lifetime_donations_wb_c = payload },
    set_lifetimeDonationsPlt: (state, payload)=> { state.lifetime_donations_plt_c = payload },
    set_lifetimeDonationsDrbc: (state, payload)=> { state.lifetime_donations_drbc_c = payload },
    set_lifetimeDonationsAlyrp: (state, payload)=> { state.lifetime_donations_alyrp_c = payload },
    set_lifetimeDonationsTotal: (state, payload)=> { state.lifetime_donations_total_c = payload },
    set_newDonor: (state, payload)=> { state.newDonor = payload },

    set_previousDonations: (state, payload)=> {
        state.previousDonation = payload
    },
    set_donorEligibility: (state, payload)=> {
        state.donorEligibility = payload
    },
    set_futureDonates: (state, payload)=> {
        state.futureDonates = payload
    },
    set_donorCharacteristics: (state, payload)=> {
        state.donorCharacteristics = payload
    },
    set_clearTemporaryDonorInformation: state => {
        state.idDonor = ''
        state.lastName = ''
    },
    set_constructorState: (state) => {
        Object.keys(state.stateDefault).forEach(key=>{
            if(key !== 'stateDefault'){
                state[key] = state.stateDefault[key]
            }
        })
    },
    set_destructorState: (state) => {
        Object.keys(state).forEach(key=>{
            if(key !== 'stateDefault'){
                delete state[key]
            }
        })
    }
}
